/*
 * Vous pouvez ajouter vos routes ici, et �galement r��crire celle existante.
 * La page de Login ne devrait pas �tre modifi� puisqu'elle est accessible uniquement en mode d�veloppement.
 * Si vous d�finissez la variable d'environnement VUE_APP_REDIRECT_URL, une redirection automatique emp�chera d'acc�der � la page.
 * Plus de documentation sur notre wiki:
 * http://venezia.appli.dgfip/plugins/mediawiki/wiki/frameworkjs/index.php/Arborescence_FrameworkJS#Routes_.26_Router
     {
        path: '/',
        name: 'Accueil',
        component: () => import('@/pages/Home/Home.vue'),
    },
 
*/
const routesConfig = [

    {
        path: '/Formulaire',
        name: 'VerifAvis2',
        component: () => import('@/pages/Formulaire/Formulaire.vue'),
        meta: {
            middleware: {
                auth: false
            }
        }
    },
    {
        path: '/',
        name: 'VerifAvis2',
        component: () => import('@/pages/Formulaire/Formulaire.vue'),
        meta: {
            middleware: {
                auth: false
            }
        }
    },
    {
        path: '/loginApim',
        name: 'LoginApim',
        beforeEnter: (to, from, next) => {
            const redirect = sessionStorage.getItem("routeClir") || '/';
            return next(redirect);
        },
        component: () => import('@/pages/Login/LoginApim.vue'),
        meta: { title: 'Apim Login' },
    },
    {
        path: '/login',
        name: 'Login',
        beforeEnter: (to, from, next) => {
            if (process.env.VUE_APP_REDIRECT_URL) {
                window.location = process.env.VUE_APP_REDIRECT_URL;
            } else {
                return next();
            }
        },
        component: () => import('@/pages/Login/Login.vue'),
        meta: { layout: "WithHeader", title: 'Login' },
    },
    {
        path: '*',
        name: 'Error',
        component: () => import('@/pages/Error/Error.vue'),
        props: { notFound: true },
        meta: { title: 'Erreur' },
    }
    ,
    {
        path: '/conforme',
        name: 'Conforme',
        component: () => import('@/pages/AvisConforme/AvisConforme.vue'),
        meta: {
            middleware: {
                auth: false
            }
        },
    }
    ,
    {
        path: '/nonconforme',
        name: 'NonConforme',
        component: () => import('@/pages/AvisNonConforme/AvisNonConforme.vue'),
        meta: {
            middleware: {
                auth: false
            }
        },
    }
    ,
    {
        path: '/erreur',
        name: 'Erreur',
        component: () => import('@/pages/Erreur/Erreur.vue'),
        meta: {
            middleware: {
                auth: false
            }
        },
    }
];
export default routesConfig;